export default "__VITE_ASSET__weVZBuvo__"